import { IconDotsMessageFilled } from '@carnica/graphics';
import { ErrorScreenType } from "../../../../../shared/config";
export var getContent = function getContent(screenType) {
  if (screenType === ErrorScreenType.LOAD || screenType === ErrorScreenType.OFFLINE) {
    return {
      icon: IconDotsMessageFilled,
      title: 'ничего не загрузилось —\nобновите чат',
      subTitle: '&nbsp;',
      // устанавливаем чтобы скрыть подзаголовок в ErrorScreen(компонент ДС: если не передать то выставляется текст по умолчанию)
      isOnlyTitle: true // флаг для установки стилей(причина в компоненте ДС) TODO: после изменения компонента в carnica убрать
    };
  }
  if (screenType === ErrorScreenType.ERROR) {
    return {
      icon: IconDotsMessageFilled,
      title: 'у нас что-то сломалось',
      subTitle: 'обновите чат или возвращайтесь\nчерез 15 минут'
    };
  }
  return {
    icon: IconDotsMessageFilled,
    title: 'что-то пошло не так',
    subTitle: 'это временно, скоро всё наладим —\nзайдите позже'
  };
};